import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import {
    Play, Pause, ThumbsUp,
    ThumbsDown,
} from 'phosphor-react';
import { CircleNotch } from '@phosphor-icons/react';
import StreamSelect from '../containers/StreamSelectContainer';

const MusicCard = ({
    cover,
    isLive,
    playerStatus,
    artist,
    song,
    playLive,
    pauseMediaPlayer,
    metaType,
    currentMetaId,
    settingRating,
    rating,
    getLocalStoreRating,
    onLiked,
    onDisliked,
}) => {
    useEffect(() => {
        getLocalStoreRating();
    }, [getLocalStoreRating]);

    const [activeLikeBtn, setActiveLikeBtn] = useState(null);
    const [activeUnlikeBtn, setActiveUnlikeBtn] = useState(null);

    useEffect(() => {
        if (settingRating === false) {
            setActiveLikeBtn(null);

            setActiveUnlikeBtn(null);
        }
    }, [settingRating, rating])

    const handleActiveEffect = (likeType) => {
        if (likeType === 'like') {
            setActiveLikeBtn(true);

            onLiked();
        } else {
            setActiveUnlikeBtn(true);

            onDisliked();
        }
    }

    const voteDisabled = !artist || !song || !isLive || metaType !== 'music' || currentMetaId !== 'antena_1';
    const buttonDisabled = rating !== null || settingRating || voteDisabled;

    const imageSrc = cover ? cover.replace('1000x1000', '400x400') : 'https://a1media.antena1.com.br/image/album/400x400/default-antena1.jpg';

    const renderPlayButton = () => {
        const title = playerStatus === 'loading' ? 'Carregando...' : playerStatus === 'playing' && isLive ? 'Pausar' : 'Tocar';

        return (
            <button
                type="button"
                className={`borderDefault tw-flex tw-w-[35px] tw-justify-center tw-items-center tw-cursor-pointer tw-border-0 tw-outline-none tw-p-2 ${playerStatus === 'playing' && isLive ? 'pulseBtn' : ''}`}
                title={title}
                onClick={playerStatus === 'loading' || (playerStatus === 'playing' && isLive) ? pauseMediaPlayer : playLive}
            >
                {playerStatus === 'loading' ? (
                    <CircleNotch size={15} weight="light" className="tw-text-black tw-animate-spin" />
                ) : playerStatus === 'playing' && isLive ? (
                    <Pause size={15} className="tw-text-black hover:tw-scale-110 tw-transition-transform" />
                ) : (
                    <Play size={15} className="tw-text-black hover:tw-scale-110 tw-transition-transform" />
                )}
                <span className="visually-hidden visually-hidden-focusable">
                    {title}
                </span>
            </button>
        );
    };

    return (
        <div className="tw-w-full">
            <div className="tw-relative tw-w-full">
                <img src={imageSrc} alt={artist && song ? `Capa: ${artist} - ${song}` : 'Capa do álbum'} className="albumInitialImageArt" />
                <div className="albumInitialImageArtGradient tw-absolute tw-inset-0 tw-pointer-events-none" />
            </div>
            <div className="tw-flex tw-flex-col tw-w-full tw-h-auto tw-mt-[25px] tw-justify-start">
                <div className="tw-flex tw-flex-col tw-items-start tw-justify-start tw-mt-[25px] tw-w-full">
                    <p className="tw-text-3xl tw-font-bold tw-text-gray-800 tw-break-words tw-w-full tw-mb-[15px]">
                        {(song && song.length > 40) ? `${song.slice(0, 40)}...` : (song || 'Antena 1')}
                    </p>

                    <p className="tw-text-lg tw-text-[#1E2024] tw-break-words tw-mb-0">
                        {(artist && artist.length > 40) ? `${artist.slice(0, 40)}...` : (artist || 'O melhor do mundo da música')}
                    </p>

                </div>

                <div className="tw-flex tw-w-auto tw-my-[15px]">
                    { renderPlayButton() }

                    <div className="tw-flex">
                        <button
                            type="button"
                            onClick={() => handleActiveEffect('like')}
                            title={buttonDisabled ? 'Você já votou' : 'Gostei'}
                            disabled={buttonDisabled}
                            className={`tw-flex tw-w-[35px] tw-h-[35px] tw-justify-center tw-items-center  tw-border-0 tw-outline-none tw-p-2 
                                ${activeLikeBtn === true ? 'pulseBtn' : ''}
                                ${buttonDisabled ? 'tw-opacity-50 tw-cursor-default' : 'tw-cursor-pointer borderDefault'}
                                ${settingRating === false && rating === 10 ? 'borderGreen' : 'borderDefault'}
                                `}
                        >
                            <ThumbsUp
                                size={15}
                                className={settingRating === false && rating === 10 ? 'tw-text-green-800' : 'tw-text-gray-800'}
                                weight={settingRating === false && rating === 10 ? 'fill' : 'regular'}
                            />
                        </button>

                        <button
                            type="button"
                            onClick={() => handleActiveEffect('dislike')}
                            title={buttonDisabled ? 'Você já votou' : 'Não gostei'}
                            disabled={buttonDisabled}
                            className={`tw-flex tw-w-[35px] tw-h-[35px] tw-justify-center tw-items-center tw-border-0 tw-outline-none tw-p-2 
                                ${activeUnlikeBtn === true ? 'pulseBtn' : ''}
                                ${buttonDisabled ? 'tw-opacity-50 tw-cursor-default' : 'tw-cursor-pointer borderDefault'}
                                ${settingRating === false && rating === 1 ? 'borderRed' : 'borderDefault'}
                                `}
                        >
                            <ThumbsDown
                                size={15}
                                className={settingRating === false && rating === 1 ? 'tw-text-red-800' : 'tw-text-gray-800'}
                                weight={settingRating === false && rating === 1 ? 'fill' : 'regular'}
                            />
                        </button>

                    </div>


                </div>

                <div className="tw-flex tw-mt-[10px] tw-w-full">
                    <StreamSelect />
                </div>
                {/*
                isLive && (
                    <span className="tw-block tw-mx-auto tw-mt-3 tw-text-[12px] tw-text-gray-600 tw-text-center tw-border tw-border-gray-300 tw-rounded-full tw-w-[70px] tw-font-sans">
                        Ao vivo
                    </span>
                )

                */
                }

            </div>
            {/*
            <div className="tw-absolute tw-w-[90px] tw-h-[90px] tw-bg-red-600 tw-rounded-full tw-drop-shadow-lg tw-animate-ballOne" />
            <div className="tw-absolute tw-w-[90px] tw-h-[90px] tw-bg-bluePrimary tw-rounded-full tw-drop-shadow-lg tw-animate-ballTwo" />
            */}
        </div>
    );
};

MusicCard.propTypes = exact({
    cover: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
    artist: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
    song: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
    isLive: PropTypes.bool.isRequired,
    playerStatus: PropTypes.string.isRequired,
    playLive: PropTypes.func.isRequired,
    pauseMediaPlayer: PropTypes.func.isRequired,
    metaType: PropTypes.string,
    currentMetaId: PropTypes.string.isRequired,
    settingRating: PropTypes.bool.isRequired,
    rating: PropTypes.number,
    getLocalStoreRating: PropTypes.func.isRequired,
    onLiked: PropTypes.func.isRequired,
    onDisliked: PropTypes.func.isRequired,
});


export default MusicCard;


